import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import Pagination from 'react-js-pagination';
import { LoaderLista } from '~/components/Loaders';
import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import InputAutoSelect from '~/components/InputAutoSelect';
import { ExtratoIndustria } from '~/components/ExtratoDataSemNotas/ExtratoIndustria';
import { FiltroExtratoCredito } from '~/components/Filtros/FiltroExtratoCredito';
import {
	ExtratoSimples,
	CardSimples,
} from '../../../components/ExtratoData/ExtratoSimples';

import {
	ExtratoSimples as ExtratoSimplesSemNotas,
} from '../../../components/ExtratoDataSemNotas/ExtratoSimples';
import { ContainerExtrato } from './styles';

import { ExtratoContext } from '../../../context/ExtratoContext';



export default function Extrato(props) {
	const { user, isMobile } = props;
	
	const {
		dataSaldo,
		totalItems,
		loadingExtrato,
		totalCreditados,
		totalDebitados,
		totalCredito,
		dataExtrato,
		dataExtratoIndustria,
		revendaHierarquiaList,
		getExtrato,
		getSaldo,
		getGrupo,
		getExtratoIndustria,
		getHierarquiaByDoc
	} = useContext(ExtratoContext);
	const [cargo, setCargo] = useState('');
	const [revendaId, setRevendaId] = useState('');
	const [filtroData, setFiltroData] = useState('');
	const [filtroPesquisa, setFiltroPesquisa] = useState('');
	const [filtroTipo, setFiltroTipo] = useState(
		{
			creditados: true,
			debitados: true,
		}
	);
	const [filtroRevendaHierarquia, setFiltroRevendaHierarquia] = useState('');
	const [pagina, setPagina] = useState(1);

	function handlerPagination(page) {
		setPagina(page);

		if(user.dados.permissoes.view_extrato_industria_ems){
			getExtratoIndustria(filtroData, filtroPesquisa, page);
		}else{
			getExtrato(user.dados.documento, page, filtroData, filtroTipo, filtroPesquisa, revendaId, filtroRevendaHierarquia)
		}
	}

	useEffect(() => {
		getGrupo(user.dados.lojista_id);
		getSaldo(user.dados.documento, revendaId);
		if(user.dados.permissoes.view_extrato_industria_ems){
			getExtratoIndustria(filtroData, filtroPesquisa, pagina);
		}else{
			getExtrato(user.dados.documento, pagina, filtroData, filtroTipo, filtroPesquisa, revendaId, filtroRevendaHierarquia);
		}

		if(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.cargo.toLowerCase() !== 'distribuidor - filial'){
			setCargo('participante')
			if(revendaHierarquiaList.length === 0){
				getHierarquiaByDoc(user.dados.documento)
			}
		}else if(user.dados.cargo.toLowerCase() === 'industria'){
			setCargo('industria')
			if(revendaHierarquiaList.length === 0){
				getHierarquiaByDoc(user.dados.documento)
			}
		}else {
			setCargo('revenda')
		}
	}, []);

	useEffect(() => {
		if (filtroData || filtroTipo || filtroPesquisa === '' || filtroPesquisa.length > 0) {
			getGrupo(user.dados.lojista_id);
			getSaldo(user.dados.documento, revendaId, filtroData);
			if(user.dados.permissoes.view_extrato_industria_ems){
				getExtratoIndustria(filtroData, filtroPesquisa, pagina);
			}else{
				getExtrato(user.dados.documento, pagina, filtroData, filtroTipo, filtroPesquisa, revendaId, filtroRevendaHierarquia);
			}
		}
	}, [filtroData, filtroTipo, filtroPesquisa, revendaId, filtroRevendaHierarquia]);

	const options = useMemo(() =>[{"documento": "","nome": "Todos"}, ...revendaHierarquiaList], [revendaHierarquiaList]);

	const selectedValue = options.find(opt => opt.documento === filtroRevendaHierarquia) || null;


	return (
		<ContainerExtrato fluid>
			<FiltroExtratoCredito
				user={user}
				setFiltroData={setFiltroData}
				setPagina={setPagina}
				setFiltroTipo={setFiltroTipo}
				filtroTipo={filtroTipo}
				setFiltroPesquisa={setFiltroPesquisa}
				revendaId={revendaId}
				setRevendaId={setRevendaId}
				filtroPesquisa={filtroPesquisa}
				filtroData={filtroData}
				extratos={dataExtrato}
				filtroRevendaHierarquia={filtroRevendaHierarquia}
				setFiltroRevendaHierarquia={setFiltroRevendaHierarquia}
				page={pagina}
			>
			{(cargo === 'participante' || cargo === 'industria')
				&& revendaHierarquiaList.length > 0 &&
				<FormGroup>
					<Label style={{ fontWeight: 'bold' }}>
						{cargo === 'industria'
						? 'Filtrar por Distribuidor:'
						: 'Filtrar por Revenda:'}
					</Label>
					<InputAutoSelect
						options={options}
						getOptionLabel={(item) => `${item?.nome || ''}` || ''}
						isOptionEqualToValue={(option, value) => {
							return option.documento === value;
						}}
						value={selectedValue}
						onChangeOption={(evt, select) => {
							setPagina(1)
							setFiltroRevendaHierarquia(select?.documento || '')
						}}
					/>
				</FormGroup>
			}

			</FiltroExtratoCredito>

			{/*
				Card de creditados/debitados liberado para todos os distribuidores.
				Anteriormente a exibição dependia da permissão:
				user.dados.permissoes.view_card_simples_extrato
			*/}
			{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria'  ?
				<CardSimples
					total={{creditados: totalCreditados, debitados: totalDebitados, credito: totalCredito}}
					user={user}
					dataSaldo={dataSaldo}
					extratos={dataExtrato}
					loadingExtrato={loadingExtrato}
				/>
				:
				<></>
			}
			<Row className="mt-5">
				<Col>
					{user.dados.permissoes.view_extrato_industria_ems && (
						<LoaderLista loading={loadingExtrato} lista={dataExtratoIndustria}>
							<ExtratoIndustria
								extratos={dataExtratoIndustria}
								user={user}
								loading={loadingExtrato} />

							<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
								<Pagination
									activePage={pagina}
									totalItemsCount={totalItems}
									onChange={(page) => handlerPagination(page)}
									prevPageText={<ChevronLeftOutlined />}
									nextPageText={<ChevronRightOutlined />}
									firstPageText={<FirstPageOutlined />}
									lastPageText={<LastPageOutlined />}
								/>
							</div>
						</LoaderLista>
					)}

					{!user.dados.permissoes.view_extrato_industria_ems && (
						<LoaderLista loading={loadingExtrato} lista={dataExtrato}>
							{!user.dados.permissoes.view_nf && (
								<ExtratoSimplesSemNotas
									extratos={dataExtrato}
									user={user}
									loadingExtratos={loadingExtrato}
								/>
							)}

							{user.dados.permissoes.view_nf && (
								<ExtratoSimples
									extratos={dataExtrato}
									user={user}
									loadingExtratos={loadingExtrato}
								/>
							)}

							<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
								<Pagination
									activePage={pagina}
									totalItemsCount={totalItems}
									onChange={(page) => handlerPagination(page)}
									prevPageText={<ChevronLeftOutlined />}
									nextPageText={<ChevronRightOutlined />}
									firstPageText={<FirstPageOutlined />}
									lastPageText={<LastPageOutlined />}
								/>
							</div>
						</LoaderLista>
					)}
				</Col>
			</Row>
		</ContainerExtrato>
	);
}
